import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

import { useInvalidateClientProfile } from './get-client-profile'

interface UpdateClientActiveStatusRequest {
  active: boolean
}

const updateClientActiveStatus = async (
  clientId: string,
  data: UpdateClientActiveStatusRequest,
) => {
  const response = await authAPI.put(`/client/${clientId}`, data)
  return response.data
}

export const useUpdateClientActiveStatus = (clientId: string) => {
  const invalidate = useInvalidateClientProfile(clientId)

  return useMutation({
    mutationFn: (data: UpdateClientActiveStatusRequest) => updateClientActiveStatus(clientId, data),
    onSuccess: invalidate,
  })
}
